export default {"src":"/_next/static/media/handle_calendar.1edaf7e2.svg","height":83,"width":66,"blurWidth":0,"blurHeight":0};